import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

const CARD_RADIUS = '24px';

export const CardButton = styled.button`
  display: flex;
  align-items: flex-start;
  gap: ${space[5]};
  width: 100%;
  padding: ${space[6]};
  background: ${colors.white};
  border: 1px solid ${semantic.border.subtle};
  border-radius: ${CARD_RADIUS};
  cursor: pointer;
  text-align: left;
  font-family: ${fonts.body};
  color: ${semantic.text.primary};
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:hover:not(:disabled) {
    background: ${semantic.bg.surfaceSubtle};
    border-color: ${semantic.border.default};
  }
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 64px;
  height: 48px;
  padding: 0 ${space[4]};
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${layout.borderRadiusFull};
  color: ${semantic.text.primary};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  flex-shrink: 0;
`;

export const TextGroup = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const Title = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: 1.4;
  color: ${semantic.text.primary};
`;

export const Description = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  line-height: 1.4;
  color: ${semantic.text.secondary};
`;
